'use client';

import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';

export default function NewCarsLandingData() {
  useDataDogRUM();
  useTrackClickEvents();

  return null;
}
